<template>
  <v-container>
    <v-row class="mt-5" align="center" justify="center">
      <v-col lg="6" md="8" sm="10" xl="4" cols="12">
        <v-form ref="form" v-model="valid" @submit.prevent="">
          <v-subheader class="pa-0">Fabrikant</v-subheader>
          <v-card class="themed-color">
            <v-card-text>
              <VTextField
                :counter="100"
                :rules="[(v) => !!v || 'Naam is verplicht', v => serverError('name'), (v) => !!v && v.length <= 100 || 'de naam mag maximaal 100 tekens bevatten']"
                label="Naam"
                autofocus
                v-model="values.name"/>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Form from './../BaseForm';

export default {
  name: 'ManufacturerForm',
  extends: Form,
};
</script>
